if (!window.dAgency) window.dAgency = {};

window.dAgency.initAccordions = () => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion-content');
      this.exception = document.querySelector('body');
      this.count = 0;

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (!this.el.dataset.index) {
        this.el.dataset.index = new Date().getTime();
      }
      this.dataIndex = this.el.dataset.index;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 800,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
      if(this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure[open]:not([data-index="'+this.dataIndex+'"]) summary').trigger('click');
      }
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';

      if (!this.exception.classList.contains('template-cart')) {
        const gift_wrapper =  document.querySelector('.gift-wrapping');
        const cartContainer = document.getElementById('CartContainer').querySelector('.ajaxcart__inner');
        const initialGap = gift_wrapper.getAttribute('initial-gap');

        if(!!gift_wrapper == false || !!cartContainer == false){
            return;
        }

        const addHeight = gift_wrapper.clientHeight;
        const cartContainerBottom = cartContainer.style.getPropertyValue('bottom');

        if (this.count == 0) {
          cartContainer.setAttribute('original-height', cartContainerBottom);
        }

        const newBottom = (parseInt(addHeight) + parseInt(cartContainer.getAttribute('original-height')) - parseInt(initialGap));
        cartContainer.style.bottom = newBottom + "px"

        this.count++;
      }
    }
  }

  document.querySelectorAll('details').forEach((el) => {
    if (el.querySelector('summary') && el.querySelector('.accordion-content')) {
      new Accordion(el);
    }
  });
}

window.dAgency.initAccordions();
